export const SYSTEM_DATE_FORMAT = 'Y/m/d H:i:s';
export const HOST_DEV = 'https://local.holdshort.com/';
export const HOST_TEST = '';
export const HOST_PROD = 'https://holdshort.com/';

export const EVENT_TYPES = {
  air: 'Regular',
  maintenance: 'Maintenance'
};

export const EVENT_TYPES_LIST = Object.keys(EVENT_TYPES);
